import { ThemeOptions } from '@mui/material';
import { merge } from 'lodash';

import AppBar from './appBar';
import Avatar from './avatar';
import Button from './button';
import IconButton from './iconButton';
import ListItemButton from './listItemButton';
import RangeDatePicker from './rangePicker';
import RichTreeView from './richTreeView';
import Surfaces from './surfaces';
import TextField from './textField';
import ToolBar from './toolBar';

const fontFamily = "'Somar Sans', Helvetica, Arial, sans-serif";

// Base component overrides
const baseComponents = (theme: ThemeOptions) => ({
  MuiTypography: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontFamily,
        // Tabular figures are what let a column of numbers align on the
        // decimal. Applied app-wide: every table in the admin reads better
        // for it, and it is purely a figure-width change — no reflow of
        // non-numeric cells.
        fontVariantNumeric: 'tabular-nums'
      }
    }
  },
  MuiList: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        fontFamily
      }
    }
  }
});

export default function ComponentsOverrides(theme: ThemeOptions) {
  return merge(
    baseComponents(theme),
    Button(theme),
    AppBar(theme),
    IconButton(theme),
    ToolBar(theme),
    ListItemButton(theme),
    Avatar(theme),
    RichTreeView(theme),
    TextField(theme),
    RangeDatePicker(theme),
    Surfaces(theme)
  );
}
